import routerOptions0 from "/home/runner/work/Laam-Nuxt3/Laam-Nuxt3/node_modules/.pnpm/nuxt@3.10.3_@parcel+watcher@2.4.1_@types+node@20.12.7_encoding@0.1.13_eslint@8.57.0_ior_bc15475070f748f6b6db5740479db184/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}